import { render, staticRenderFns } from "./VendorUploadFileDialog.vue?vue&type=template&id=66da54bb&"
import script from "./VendorUploadFileDialog.vue?vue&type=script&lang=ts&"
export * from "./VendorUploadFileDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports